import React from 'react';

const TermsAndConditionContent = () => {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4 text-base-content leading-relaxed space-y-6">
      <div className="border-b border-base-200 pb-4 mb-6">
        <h1 className="text-3xl font-extrabold text-base-content mb-2">
          TERMS AND CONDITIONS OF USE
        </h1>
        <p className="text-sm font-semibold text-base-content/70">
          Effective Date: August 4, 2026
        </p>
        <p className="text-sm font-semibold text-base-content/70">
          Website: insuranceenterpriseusa.com
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">1. Acceptance of Terms</h2>
        <p>
          Welcome to Insurance Enterprise USA ("Company," "we," "us," or "our"). These Terms and Conditions ("Terms") govern your access to and use of the website located at insuranceenterpriseusa.com, including all subdomains, online quote forms, calculators, digital resources, and related services (collectively, the "Site").
        </p>
        <p>
          By accessing, browsing, requesting a quote, submitting information, or otherwise using the Site, you agree to be bound by these Terms. If you do not agree to these Terms, you must discontinue your use of the Site.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">2. Scope of Services and Entity Disclosure</h2>
        <p>
          Insurance Enterprise USA operates as a licensed insurance entity subject to applicable federal and state insurance laws and regulations.
        </p>
        <p>
          The Site is provided as an informational resource and digital intake platform that allows individuals, families, employers, and organizations to request insurance quotes and learn about available insurance products and services.
        </p>
        <p>
          Submitting an inquiry, quote request, or application through the Site does not create an insurance binder, policy, or guarantee of coverage. All insurance coverage is subject to eligibility requirements, underwriting review, carrier approval, and the issuance of a policy by the applicable insurance carrier.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">3. User Eligibility and Accurate Information</h2>
        <p>By using this Site, you represent and warrant that:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>You are at least eighteen (18) years of age.</li>
          <li>You have the legal authority to submit information for yourself or for the person or organization you represent.</li>
          <li>All information you provide is accurate, current, complete, and truthful.</li>
        </ul>
        <p>
          Providing false, misleading, or fraudulent information may result in denial of services and any other remedies available under applicable law.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">4. Intellectual Property and Acceptable Use</h2>
        <p>
          All content available on the Site, including text, graphics, logos, images, software, design elements, trademarks, and other materials, is owned by or licensed to Insurance Enterprise USA and is protected by applicable intellectual property laws.
        </p>
        <p>You agree not to:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Copy, reproduce, distribute, or create derivative works from Site content without prior written permission;</li>
          <li>Use automated tools, bots, scrapers, crawlers, or similar technologies to collect Site content or data;</li>
          <li>Attempt to gain unauthorized access to the Site or its systems;</li>
          <li>Interfere with the operation, integrity, or security of the Site; or</li>
          <li>Use the Site for any unlawful purpose.</li>
        </ul>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">5. Website Information and Disclaimer</h2>
        <p>
          The information, educational materials, quote tools, calculators, and other resources provided on this Site are offered solely for general informational purposes.
        </p>
        <p>
          Any quote or premium estimate generated through the Site is a non-binding estimate based upon the information provided by the user. Final eligibility, premiums, benefits, policy terms, and coverage determinations are made solely by the applicable insurance carrier through its underwriting process.
        </p>
        <p>
          Although we strive to maintain accurate and current information, Insurance Enterprise USA does not warrant that the Site will always operate uninterrupted, be error-free, or remain continuously available.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">6. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by applicable law, Insurance Enterprise USA, together with its affiliates, officers, directors, employees, agents, licensors, and service providers, shall not be liable for any indirect, incidental, consequential, special, exemplary, or punitive damages arising out of or relating to your access to, use of, or inability to use the Site, even if advised of the possibility of such damages.
        </p>
        <p>
          Nothing in these Terms excludes or limits liability where such exclusion or limitation is prohibited by applicable law.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">7. Force Majeure</h2>
        <p>
          Insurance Enterprise USA shall not be responsible for any delay or failure to perform its obligations under these Terms when such delay or failure results from events beyond its reasonable control, including but not limited to natural disasters, severe weather, fire, flood, pandemic, epidemic, labor disputes, governmental actions, war, terrorism, civil unrest, utility failures, internet or telecommunications disruptions, cyber incidents, or other unforeseen events beyond our reasonable control.
        </p>
        <p>
          Performance shall resume as soon as reasonably practicable following the end of the applicable event.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">8. Third-Party Services</h2>
        <p>
          The Site may contain links to, integrate with, or reference third-party websites, software applications, insurance carriers, or other external services for your convenience.
        </p>
        <p>
          Insurance Enterprise USA does not own or control these third-party services and is not responsible for their availability, content, accuracy, privacy practices, security, products, or services. Your use of third-party services is governed solely by the terms and policies of those providers.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">9. Indemnification</h2>
        <p>
          To the extent permitted by applicable law, you agree to indemnify, defend, and hold harmless Insurance Enterprise USA, its affiliates, officers, directors, employees, agents, licensors, contractors, and service providers from and against any third-party claims, liabilities, damages, judgments, losses, costs, expenses, and reasonable attorneys' fees arising out of or relating to:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Your violation of these Terms;</li>
          <li>Your misuse of the Site;</li>
          <li>Information submitted by you that is false, misleading, or unlawful;</li>
          <li>Your violation of applicable law; or</li>
          <li>Your infringement of the rights of any third party.</li>
        </ul>
        <p>
          This obligation survives termination of your use of the Site.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">10. Suspension or Termination of Access</h2>
        <p>
          Insurance Enterprise USA reserves the right to suspend, restrict, or terminate access to the Site, in whole or in part, at any time and for any lawful reason, including where we reasonably believe a user has violated these Terms, engaged in fraudulent or unlawful conduct, compromised Site security, or interfered with the operation of the Site.
        </p>
        <p>
          Termination shall not affect any rights or obligations that accrued before termination.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">11. No Professional Advice</h2>
        <p>
          The information available on this Site is provided solely for general informational purposes.
        </p>
        <p>
          Nothing on the Site constitutes legal, tax, accounting, financial, medical, or other professional advice. Users should consult appropriately qualified professionals regarding their individual circumstances before making decisions regarding insurance or related matters.
        </p>
        <p>
          No information provided through the Site creates an attorney-client, fiduciary, physician-patient, or other professional relationship.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">12. Reservation of Rights</h2>
        <p>
          Insurance Enterprise USA reserves all rights not expressly granted under these Terms.
        </p>
        <p>
          We may modify, suspend, discontinue, or update any portion of the Site, its content, functionality, products, or services at any time, subject to applicable law. Such modifications shall not affect rights or obligations that accrued before the effective date of the modification.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">13. Dispute Resolution</h2>
        <p>
          The parties agree to make a good-faith effort to resolve any dispute informally before initiating legal proceedings.
        </p>
        <p>
          Except where prohibited by applicable law or where arbitration is determined to be unenforceable, disputes arising out of or relating to these Terms shall be resolved through binding arbitration on an individual basis.
        </p>
        <p>
          If a court of competent jurisdiction determines arbitration is unenforceable for a particular claim, that claim shall be brought exclusively in the state or federal courts located in the jurisdiction where Insurance Enterprise USA maintains its principal place of business, and the parties consent to the personal jurisdiction and venue of those courts.
        </p>
        <p>
          Nothing in these Terms limits any non-waivable rights or remedies available under applicable law.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">14. Regulatory Compliance and Governing Law</h2>
        <p>
          These Terms shall be governed by and construed in accordance with applicable federal law and the laws of the state in which Insurance Enterprise USA maintains its principal place of business, without regard to conflict-of-law principles.
        </p>
        <p>
          Insurance Enterprise USA operates in compliance with applicable state insurance laws and federal regulations. Nothing in these Terms limits any consumer protections that cannot be waived under applicable law.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">15. Severability</h2>
        <p>
          If any provision of these Terms is determined by a court of competent jurisdiction to be invalid, illegal, or unenforceable, that provision shall be modified only to the extent necessary to make it enforceable, and the remaining provisions shall remain in full force and effect.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">16. Entire Agreement</h2>
        <p>
          These Terms, together with any policies expressly incorporated by reference, constitute the entire agreement between you and Insurance Enterprise USA regarding your use of the Site and supersede all prior or contemporaneous understandings relating to the Site.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">17. Changes to These Terms</h2>
        <p>
          Insurance Enterprise USA may revise these Terms from time to time. Updated versions become effective upon posting to the Site unless otherwise stated. Continued use of the Site after the effective date of any revision constitutes acceptance of the revised Terms.
        </p>
      </div>

      <div className="space-y-4 border-t border-base-200 pt-6">
        <h2 className="text-xl font-bold text-base-content">18. Contact Information</h2>
        <p className="font-semibold">Insurance Enterprise USA</p>
        <p>Phone: 888-350-6605</p>
        <p>Email: enroll@insuranceenterpriseusa.com</p>
        <p>Website: insuranceenterpriseusa.com</p>
      </div>
    </div>
  );
};

export default TermsAndConditionContent;
